import React from "react";

import AddLead from "./AddLead";

export const AddLeadIndex: React.FC = () => {
  return <AddLead />;
};
